const YNS_API_KEY = process.env.YNS_API_KEY;

export const env = {
	YNS_API_KEY,
};
